import { render, staticRenderFns } from "./CompanyDetail.vue?vue&type=template&id=3cf81d9c&"
import script from "./CompanyDetail.vue?vue&type=script&lang=js&"
export * from "./CompanyDetail.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports